"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "className", "description", "imgProps", "imgSrc", "small", "title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayEmptyState = function ClayEmptyState(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? 'Sorry, there are no results found' : _ref$description,
      imgProps = _ref.imgProps,
      imgSrc = _ref.imgSrc,
      small = _ref.small,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'No results found' : _ref$title,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var hasImg = imgSrc || imgProps;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(className, 'c-empty-state', {
      'c-empty-state-animation': hasImg,
      'c-empty-state-sm': small
    })
  }, otherProps), hasImg && /*#__PURE__*/_react.default.createElement("div", {
    className: "c-empty-state-image"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-empty-state-aspect-ratio"
  }, /*#__PURE__*/_react.default.createElement("img", _extends({
    alt: "c-empty-state-image",
    className: (0, _classnames.default)('aspect-ratio-item aspect-ratio-item-fluid', imgProps && imgProps.className),
    src: imgSrc
  }, imgProps)))), title && /*#__PURE__*/_react.default.createElement("div", {
    className: "c-empty-state-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-truncate-inline"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-truncate"
  }, title))), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-empty-state-text"
  }, description), children && /*#__PURE__*/_react.default.createElement("div", {
    className: "c-empty-state-footer"
  }, children));
};

var _default = ClayEmptyState;
exports.default = _default;